var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProButtonRightInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3456_14)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1773 12.1649C14.3915 11.9478 14.746 11.9478 14.9602 12.1649L18.8376 16.0959C19.0517 16.313 19.0517 16.6724 18.8376 16.8896L14.9602 20.8205C14.7534 21.0451 14.3989 21.0601 14.1773 20.8505C13.9557 20.6408 13.941 20.2814 14.1478 20.0568C14.1551 20.0493 14.1625 20.0343 14.1773 20.0268L17.6633 16.4927L14.1773 12.9586C13.9631 12.7415 13.9631 12.3821 14.1773 12.1649Z",
    fill: "#A9A9A9"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16,
    stroke: "#A9A9A9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3456_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 9,
    fill: "white",
    transform: "translate(14 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProButtonRightInactive);
export default __webpack_public_path__ + "static/media/pro-button-right-inactive.276728f0254311be23198073f158efd8.svg";
export { ForwardRef as ReactComponent };